<template>
  <tr>
    <td
      class="text-center align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <span class="form-control form-control-plaintext">{{rowIndex + 1}}</span>
    </td>
    <td
      class="form-group text-center align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <!-- <input
        type="text"
        class="form-control required"
        placeholder="เลขที่ใบส่งสินค้า"
        :readonly="!isEditable"
        v-model="item.documentNumber"
        data-msg-required="กรุณากรอกเลขที่ใบส่งสินค้า"
        @blur="onDocumentNumberBlur"
      />
      <span class="form-text"></span>-->
      {{item.documentNumber}}
    </td>
    <td
      v-if="showHeader"
      class="form-group text-center align-middle"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >{{item.documentDate}}</td>
    <td
      class="form-group align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      {{item.shipToName}}
      ({{item.shipTo}})
    </td>
    <template v-if="item.items.length > 0">
      <td
        class="align-middle"
      >{{item.items[itemIndex].materialCode}} {{item.items[itemIndex].materialName}}</td>
      <td class="text-right align-middle">{{item.items[itemIndex].quantity}}</td>
      <td class="text-right align-middle">{{item.items[itemIndex].salesUnit}}</td>
    </template>
    <template v-else>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
    </template>
    <td
      v-if="showHeader"
      class="text-center align-middle"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <button
        v-if="isEditable && jobType != 'RETRIEVE_ITEM'"
        type="button"
        class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
        title="ลบรายการ"
        @click.prevent="onRemoveItemClick"
      >
        <i class="text-danger la la-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    itemIndex: Number,
    showHeader: {
      type: Boolean,
      default: true
    },
    rootItems: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    jobType: {
      type: String
    }
  },
  data() {
    return {
      oldDocumentNumber: null
    };
  },
  methods: {
    onDocumentNumberBlur() {
      let self = this;

      var hasDocNumber =
        $.grep(self.rootItems, function(obj, i) {
          return (
            i != self.rowIndex && obj.documentNumber == self.item.documentNumber
          );
        }).length > 0;

      if (hasDocNumber) {
        Swal.fire("เกิดข้อผิดพลาด", "คุณกรอกเลขที่ใบส่งสินค้าซ้ำ", "warning");
        return false;
      }

      if (
        self.item.documentNumber &&
        self.oldDocumentNumber != self.item.documentNumber
      ) {
        self.oldDocumentNumber = self.item.documentNumber;

        axios
          .get("/Api/DeliveryOrders/" + encodeURIComponent(self.item.documentNumber))
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data;
              self.item.id = data.id;
              self.item.documentNumber = data.documentNumber;
              self.item.documentDate = data.documentDate;
              self.item.items = data.items;

              self.$parent.onCalculateItemClick();
            } else {
              self.item.id = null;
              self.item.documentDate = null;
              self.item.items = [];

              Swal.fire(
                "เกิดข้อผิดพลาด",
                "ไม่พบข้อมูลใบส่งสินค้า " +
                  self.item.documentNumber +
                  "<br />ทั้งนี้อาจจะเกิดจากความล่าช้าในการ Sync ข้อมูลจากฐานข้อมูล SAP<br /><br />หากคุณยืนยันความถูกต้องของเลขที่ใบส่งสินค้านี้ คุณสามารถคงค่านี้ไว้ได้ระบบจะดำเนินการผูกข้อมูลให้อัตโนมัติในภายหลังที่ได้รับข้อมูลจากฐานข้อมูล SAP แล้ว",
                "warning"
              );
            }
          })
          .catch(function(error) {
            self.item.id = null;
            self.item.documentDate = null;
            self.item.items = [];

            Swal.fire(
              "เกิดข้อผิดพลาด",
              "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลใบส่งสินค้าได้ในขณะนี้",
              "error"
            );
          });
      } else {
        self.item.id = null;
        self.item.documentDate = null;
        self.item.items = [];
      }
    },
    onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    }
  },
  mounted() {
    $(".required", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Job/JobRefDocumentRow.vue